import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash'
import {
  Button,
  Form, FormGroup,
  Input, Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Card, CardBody
} from 'reactstrap';

import Lang from 'Lang/General';
import { AutomationEmail } from './assets'
import MultilingualRTE from 'components/MultiLangRTE'
import MultilingualInput from 'components/MultiLangInput/v2'

import DeleteConfirmationModal from 'components/Modal/deleteConfirmation'

function IndustryForm({
  data,
  mode,
  deleteAutomationEmail,
  selectedScenarioID,
  updateAutomationEmail,
  postAutomationEmail,
  onClose,
  selectedAutomationEmails
}) {
  const emailEditorRef = useRef(null)
  const [currentEditIndex, setCurrentEditIndex] = useState(null)
  const [formData, setFormData] = useState(AutomationEmail)
  const [hasMapped, setHasMapped] = useState(false)
  const [processedScenarioText, setScenarioText] = useState([])
  const [selectedDeleteEmail, setSelectedDeleteEmail] = useState(null)

  useEffect(() => {
    if (selectedScenarioID) {
      let temp = Lang[ selectedScenarioID.scenario ][ data.languageReducer.userSettings.admin_panel_language ]
      let tempSplit = temp.split('[X]')

      setScenarioText(tempSplit)
    }
  }, [selectedScenarioID])

  useEffect(() => {
    if(currentEditIndex !== null ){
      let temp = _.cloneDeep(selectedAutomationEmails[currentEditIndex])
      if (typeof temp.email_subject === 'string'){
        temp.email_subject = {
          en: temp.email_subject,
          de: ''
        }
      }
      if (typeof temp.email_content === 'string'){
        temp.email_content = {
          en: temp.email_content,
          de: ''
        }
      }
      
      setFormData(temp)
    } else {
      setFormData(AutomationEmail)
    }

    setHasMapped(true)
  }, [currentEditIndex])

  const onChangeField = (key, val) => setFormData({
    ...formData,
    [key]: val
  })

  return (
    <>
      <ModalHeader toggle={() => onClose()} >
        {Lang['UPDATE_AUTOMATION'][data.languageReducer.userSettings.admin_panel_language]}</ModalHeader>
      <ModalBody>
        <div className="d-flex flex-wrap" style={{ gap: 8 }}>
          <Button
            onClick={() => {
              setHasMapped(false)
              setCurrentEditIndex(null)
            }}
            className={'ml-2'}
            style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
            color={currentEditIndex === null ? 'primary' : 'secondary'}
          >
            { Lang['CREATE'][data.languageReducer.userSettings.admin_panel_language]}
          </Button>
          {
            selectedAutomationEmails.map((_, emailIndex) => (
              <Button
                onClick={() => {
                  setHasMapped(false)
                  setCurrentEditIndex(emailIndex)
                }}
                color={currentEditIndex === emailIndex ? 'primary' : 'secondary'}
              >
                { Lang['EMAIL'][data.languageReducer.userSettings.admin_panel_language]} 
                { ` ${ emailIndex + 1 }`}
              </Button>
            ))
          }
        </div>
        <Card>
          <CardBody>
            <Form>
              <FormGroup>
                <Label className={'d-flex align-items-center flex-wrap'}>
                  <h5 className='mb-0'>
                    {processedScenarioText?.[0]}
                  </h5>
                  <Input
                    style={{ maxWidth: 70 }}
                    value={formData.trigger_at_days_before}
                    className={'ml-1 mr-1'}
                    type={'number'}
                    onChange={e => onChangeField('trigger_at_days_before', +e.target.value)}
                  />
                  <h5 className='mb-0'>
                    {processedScenarioText?.[1]}
                  </h5>
                </Label>
              </FormGroup>
              <Label>
                {Lang['EMAIL_SETTING'][data.languageReducer.userSettings.admin_panel_language]}
              </Label>
              <div className="card p-3 mb-3 bg-primary text-white">
                <p>
                  {Lang['USE_NEWSLETTER_PLACEHOLDER'][data.languageReducer.userSettings.admin_panel_language]}
                </p>
                <ul className='mb-0'>
                  <li>{'{{ $.company_name }}'}</li>
                  <li>{'{{ $.first_last_name }}'}</li>
                </ul>
              </div>
              <MultilingualInput
                label={ Lang[ 'EMAIL_CONTENT' ][ data.languageReducer.userSettings.admin_panel_language ] }
                selectedLanguage={ data.languageReducer.userSettings.admin_panel_language }
                value={ formData.email_subject }
                valueName='email_subject'
                parent={ formData }
                onChangeValue={ ( parentName, formDataValue ) => setFormData( formDataValue ) } 
              />
              {
                hasMapped && (
                  <>
                    <MultilingualRTE
                      height={'200px'}
                      label={ Lang[ 'CONTENT' ][ data.languageReducer.userSettings.admin_panel_language ] }
                      value={ formData.email_content }
                      onChange={ val => setFormData({
                        ... formData,
                        email_content: val
                      })}
                      selectedLanguage={data.languageReducer.userSettings.admin_panel_language}
                    />
                  </>
                )
              }
            </Form>
          </CardBody>
        </Card>
      </ModalBody>
      <ModalFooter>
        {
          currentEditIndex !== null && (
            <Button
              color='danger'
              className='mr-2'
              onClick={() => {
                console.log(selectedAutomationEmails[currentEditIndex])
                setSelectedDeleteEmail(selectedAutomationEmails[currentEditIndex])
              }}
            >
              {Lang['DELETE'][data.languageReducer.userSettings.admin_panel_language]}
            </Button>
          )
        }
        <Button
          color='primary'
          onClick={() => {
            currentEditIndex !== null 
              ? updateAutomationEmail({
                ... formData,
                scenario_id: selectedScenarioID.id
              })
              : postAutomationEmail({
                ... formData,
                scenario_id: selectedScenarioID.id
              }, () => {
                Promise.all([
                  setHasMapped(false)
                ]).then(() => {
                  setFormData(AutomationEmail)
                  setHasMapped(true)
                })
              })
          }}>
          {Lang['SUBMIT'][data.languageReducer.userSettings.admin_panel_language]}</Button>
      </ModalFooter>
      {
        selectedDeleteEmail && (
          <DeleteConfirmationModal
            handleModalClose={ () => setSelectedDeleteEmail( null )}
            confirmAction={ () => { 
                deleteAutomationEmail( selectedDeleteEmail.id, selectedScenarioID.id, () => {
                  setCurrentEditIndex(null)
                  setSelectedDeleteEmail(null )
              })
            }}
            content={ Lang[ 'ARE_YOU_SURE_TO_DELETE_EMAIL' ][ data.languageReducer.userSettings.admin_panel_language ] }
            lang={ data.languageReducer.userSettings.admin_panel_language } 
          />
        )
      }
    </>
  )
}

export default IndustryForm